import { DropdownOption } from '@aslanpay/portal-common-lib';

import { countries } from 'app/constants/countries';

export const PARTNER_COUNTRY_OPTIONS: DropdownOption[] = countries.map((country) => ({
  value: country.code,
  text: country.details.name,
}));
